import { ChevronDown } from 'lucide-react';
import { type SelectHTMLAttributes, useId } from 'react';
import { inputFrame } from './TextField';

/** A native select in the HUD frame: keeps the phone's own picker and keyboard behaviour. */
export function Select({
  label,
  hideLabel = false,
  className = '',
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { label: string; hideLabel?: boolean }) {
  const id = useId();
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={
          hideLabel
            ? 'sr-only'
            : 'block font-display text-xs font-semibold uppercase tracking-[0.14em] text-muted'
        }
      >
        {label}
      </label>
      <div className={`relative ${hideLabel ? '' : 'mt-1'}`}>
        <select id={id} className={`${inputFrame} appearance-none pr-9`} {...props}>
          {children}
        </select>
        <ChevronDown
          aria-hidden
          className="pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-accent"
        />
      </div>
    </div>
  );
}
